export default "__VITE_ASSET__cfvrpg$7__"